import type { TConversationThreadMessageDTO } from '@conversed/rest/src/contracts/train-ai/train-ai.dto';

type TThreadTopic = NonNullable<TConversationThreadMessageDTO['hotTopic']>;

/**
 * The topics the conversation touched, each listed once, in the order they first came up.
 */
export const getDistinctThreadTopics = (
  messages: TConversationThreadMessageDTO[],
): TThreadTopic[] => {
  const topicsById = new Map<string, TThreadTopic>();

  for (const message of messages) {
    if (message.hotTopic && !topicsById.has(message.hotTopic.id)) {
      topicsById.set(message.hotTopic.id, message.hotTopic);
    }
  }

  return [...topicsById.values()];
};
